module.exports = __webpack_public_path__ + "static/yam-af23872c1842ec01f26eefe09eba589b.jpg";